import { DetailedIconPrivacy } from '@zillow/constellation';
import { Box, Heading, Modal, Paragraph } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

import { PRODUCT_TYPE_NAME_TO_ID } from '../../../constants/FreemiumConstants';

import ModalFooter from '../../../components/Modal/ModalFooter';

type ListingAvailabilityModalProps = {
  onModalClose: () => void;
  onConfirmClick: () => void;
};

const ListingAvailabilityModal = ({ onModalClose, onConfirmClick }: ListingAvailabilityModalProps) => {
  const {
    currentProperty: {
      freemium: { activeProduct },
    },
  } = useSelector((state) => state.properties);

  const isActiveProductTypePremium = activeProduct?.type === PRODUCT_TYPE_NAME_TO_ID.PREMIUM;

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onModalClose()}
      size={{ base: 'fullScreen', md: 'md' }}
      footer={
        <ModalFooter cancelText="Cancel" submitText="Confirm" onSubmit={onConfirmClick} onCancel={onModalClose} />
      }
      body={
        <Box css={{ paddingInline: '600' }}>
          <Box css={{ marginBottom: '600' }}>
            <DetailedIconPrivacy />
          </Box>
          <Box css={{ marginBottom: '600' }}>
            <Heading level={4}>Confirm your listing&apos;s availability</Heading>
          </Box>
          <Box css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
            <Paragraph>Renters want to know that your property is still available to rent.</Paragraph>
            <Paragraph>
              Simply confirm your availability and your listing will stay active. We&apos;ll ask you to reconfirm in 7
              days.
            </Paragraph>
            <Paragraph>
              {`If you do not confirm availability, your listing will expire, but you can reactivate anytime. ${
                isActiveProductTypePremium
                  ? "You'll maintain access to your Premium benefits for 90 days since upgrade."
                  : ''
              }`}
            </Paragraph>
          </Box>
        </Box>
      }
    />
  );
};

export default ListingAvailabilityModal;
